import { useClerk } from '@clerk/react-router';
import { useLingui } from '@lingui/react/macro';
import { APP_PATHS } from 'app-shared/constants';
import { Dropdown } from 'app-ui/components';
import { IconPlus } from 'app-ui/icon';

// Clerk's create-workspace dialog. The new workspace becomes the active one.
export const ClerkCreateWorkspaceItem = () => {
  const { t } = useLingui();
  const { openCreateOrganization } = useClerk();

  const handleCreateWorkspaceClick = () => {
    openCreateOrganization({ afterCreateOrganizationUrl: APP_PATHS.home });
  };

  return (
    <Dropdown.ActionItem
      startIcon={<IconPlus />}
      onClick={handleCreateWorkspaceClick}
    >
      {t`Create workspace`}
    </Dropdown.ActionItem>
  );
};
